import React from "react";
import ActivityListTemplate from "../components/ActivityListTemplate.tsx";
import { useTranslation } from "react-i18next";

export default function LatestActivity() {
  const {t} = useTranslation();

  return <ActivityListTemplate type="NEWEST_ACTIVITY" title={t("latestActivity")}/>;
}
